import { render, staticRenderFns } from "./DescargoGralGestionPasPage.vue?vue&type=template&id=474cfc26"
import script from "./DescargoGralGestionPasPage.js?vue&type=script&lang=js&external"
export * from "./DescargoGralGestionPasPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports